<template>
  <div class="gap-container">
    <section class="navbar">
      首页 > 留学工具 > GPA学分绩点计算器
    </section>
    <section class="form">
      <!-- <div class="table-banner">
        <a href="https://www.51offer.com/article/detail_90471.html" target="_blank" class="banner"></a>
      </div> -->
      <!--<div class="table-tool">-->
        <!--<div class="tips" @click="goAnchor('rule-detail')">计算规则说明</div>-->
        <!--<div class="download">导出成绩单</div>-->
        <!--<div class="upload">导入成绩单</div>-->
      <!--</div>-->
      <div class="table-title" style="line-height: 2;">GPA学分绩点计算器</div>
      <div class="table">
        <div class="table-header">
          <div class="label-name">课程名称（选填）</div>
          <div class="score">
            课程成绩 <span class="typeContext" @click="chooseType">- {{typeContext}}</span>
            <ul class="type-list" v-show="showList">
              <li v-for="(item, index) in typeList" @click="bindType(item)">{{item.context}}</li>
            </ul>
          </div>
          <div class="level">课程学分</div>
        </div>
        <div class="table-body">
          <div class="item" v-for="(item, index) in courses" :key="index">
            <span class="index">{{ index < 9 ? '0' + (index + 1) : index + 1}}</span>
            <input type="text" class="input-course" placeholder="课程名称"
                   v-model="item.course">
            <div class="input-wrap">
              <input type="text" class="input-score" placeholder="成绩"
                     @blur="validateM"
                     :data-validator="validators"
                     :data-name="item.id + '-0'"
                     v-model="item.score"
                     v-if="type !== 3">
              <input type="text" class="input-score" placeholder="成绩"
                     @blur="validateM"
                     v-model="item.scoreStr"
                     :data-name="item.id + '-0'"
                     :data-validator="validators"
                     v-else>
              <span class="error">{{form[item.id + '-0']}}</span>
            </div>
            <div class="input-wrap">
              <input type="text" class="input-level" placeholder="学分"
                     @blur="validateM"
                     v-model="item.level"
                     :data-name="item.id + '-1'"
                     data-validator="score,hundred,dotsingle">
              <span class="error">{{form[item.id + '-1']}}</span>
            </div>
          </div>
          <div class="add">
            <div class="add-tips" @click="goAnchor('rule-detail')">计算规则说明</div>
            <div class="add-block">
              <table>添加课程</table>
              <div class="input-block">
                <input type="text" v-model="addNum" placeholder="数目">
                <div @click="add">添加</div>
              </div>
            </div>
          </div>
          <div class="computed-wrap">
            <div class="del-button" @click="clear">清空</div>
            <div class="computed-button"
                 :class="{'computed-button-active': canSubmit, 'computed-button-computing': process === 2}"
                 @click="submit">{{result}}
            </div>
          </div>
          <div class="test">
            <a href="https://www.51offer.com/threeSteps/oneStep.html" target="_blank">测一测你能被哪所名校录取</a>
            <span></span>
          </div>
        </div>
      </div>
    </section>
    <section class="result" v-show="newData.length">
      <div class="result-title">你的GPA成绩计算结果</div>
      <div class="result-form">
        <div v-if="type === 1">
          <div class="item-title1">
            <div>统计算法</div>
            <div>GPA得分</div>
          </div>
          <div class="item item-1" v-for="(item, index) in newData1">
            <div class="name">{{item[0]}}</div>
            <div class="score">{{item[1]}}</div>
          </div>
          <div class="item-title1">
            <div>标准算法</div>
            <div>GPA得分</div>
          </div>
          <div class="item item-1">
            <div class="name">{{newData2[0]}}</div>
            <div class="score">{{newData2[1]}}</div>
          </div>
          <div class="item-title1">
            <div>其他算法</div>
            <div>GPA得分</div>
          </div>
          <div class="item item-1" v-for="(item, index) in newData" :key="index">
            <div class="name">{{item[0]}}</div>
            <div class="score">{{item[1]}}</div>
          </div>
        </div>
        <div v-else>
          <div class="item-title1">
            <div>统计算法</div>
            <div>GPA得分</div>
          </div>
          <div class="item item-1" v-for="(item, index) in newData" :key="index">
            <div class="name">{{item[0]}}</div>
            <div class="score">{{item[1]}}</div>
          </div>
        </div>
      </div>
      <div class="result-suggest">你的GPA成绩超越了 <span style="color: #F56389">{{percent}}</span> 的申请者!</div>
      <div class="result-tips">{{resultTips}}</div>
      <!-- <div class="result-button" onclick="window.open('https://51offer.udesk.cn/im_client/?web_plugin_id=46045&group_id=72691&language=zh-cn&channel=51offer-PC')"> -->
      <div class="result-button" @click="openTalk">
        免费分析我的申请成功率
      </div>
    </section>
    <section class="rule">
      <div class="rule-detail" id="rule-detail">
        <div class="title">什么是GPA</div>
        <div class="content">
          GPA全称是Grade Point Average，即均成绩点数，是大多数大学及高等教育院校所采用的一种评估学生成绩的制度。所以在申请英国等国家时，我们需要百分制加权平均分。而在申请美国院校时，我们一般需要将国内百分制分数转换成4分制，便于学校查看。但是国内的GPA算法千奇百怪，这个时候，你需要一款专业便捷的产品帮助你计算。
        </div>
        <div class="title" style="margin-top: 20px">
          GPA多少才可以申请留学，GPA多少算高，GPA多少算低？
        </div>
        <div class="content">
          GPA很重要，但是能不能申请成功，拿到offer取决于很多因素。比如，研究经验、你的学校声望、推荐信、个人陈述、套磁、GRE、GRE Sub等。增加这些方面的实力，申请成功是肯定有机会的。
        </div>
        <div class="connect">

          <!-- onclick="window.open('//tb.53kf.com/code/client/10139741/2')">点击此处咨询低GPA如何冲击国外名校</a> -->
          <a href="javascript:void(0)"
             @click="openTalk">点击此处咨询低GPA如何冲击国外名校</a>
          <span></span>
        </div>
        <div class="title" style="margin-top: 20px">
          51offerGPA计算器
        </div>
        <div class="content">
          您只需要输入您所学课程的成绩及课程所占学分，即可轻松获得您在8种流行算法下的GPA成绩。
          您也可以使用手机，在微信-小程序内搜索 <span style="font-weight: bold">智能小程序计算器</span>
        </div>
        <div class="title" style="margin-top: 150px">
          统计算法
        </div>
        <div class="content">
          统计算法暂时包含算术平均分及加权平均分。一般英国等国家院校使用加权平均分进行申请。
        </div>
        <div class="img-block">
          <img src="//s2.51offer.com/51offer/2018-03-05/rule1.png" alt="" style="width: 545px;height: 210px">
        </div>
        <div class="title">
          四分制 - 标准加权算法
        </div>
        <div class="content">
          GPA的计算一般是将每门课程的成绩乘以学分，加起来以后除以总的学分，得出平均分。
        </div>
        <div class="img-block">
          <img src="//s2.51offer.com/51offer/2018-03-05/rule2.png" alt="" style="width: 460px;height: 153px">
        </div>
        <div class="title">
          四分制 - 其它算法
        </div>
        <div class="content">
          各类计算方式大同小异。假若学生成绩为百分制，则想将学生算法兑换为对应的四分之成绩。然后进行加权平均分计算。
        </div>
        <div class="img-block">
          <img src="//s2.51offer.com/51offer/2018-03-05/rule3.png" alt="" style="width: 757px;height: 757px">
        </div>
        <div class="title">
          五分制 / 等级制算法
        </div>
        <div class="content">
          先把每门课成绩转化成对应的四分之GPA，然后将所有的GPA求“加权平均分”。
        </div>
        <div class="img-block">
          <img src="//s2.51offer.com/51offer/2018-03-05/rule4.png" alt="" style="width: 396px;height: 451px">
        </div>
        <div class="title">
          如何选算法
        </div>
        <div class="content">
          首先我们要知道，究竟什么情况下会用到GPA？<br/>
          其实只有两处，一是你的成绩单上，二是填写网申以及其他申请材料(CV)的时候。你可以根据申请院校所需的GPA分制选择你要使用的算法。例如目前英国大部分使用百分制，美国大部分使用4分制。
          <br/>
          <br/>
          至于挑选原则其实非常简单：
          哪个分高，选哪个!
          <br/>
          <br/>
          当然，如果你的成绩单上拥有GPA成绩，但却因为学校的算法选取不同，与你的计算结果大相迳庭，那其实也有办法来避免这种情况。
        </div>
        <div class="connect">
          <a href="javascript:void(0)"
             onclick="window.open('//tb.53kf.com/code/client/10139741/2')">详细的可以点击询问我们专业的辅导老师</a>
          <span></span>
        </div>
      </div>
      <div class="ad">
        <div class="gap">
        </div>
        <div class="news" id="ad-news">
          <!--<div class="news" id="ad-news" :class="{'news-fixed': fixTop}">-->
          <div class="banner">
            <img width="280" src="//s2.51offer.com/51offer/2017-06-30/article-detail.png" alt="">
          </div>
          <div class="info-section3">
            <OneStep></OneStep>
          </div>
          <span class="news-title">相关文章</span>
          <a href="https://www.51offer.com/article/detail_22.html" class="news-top" target="_blank">
            <img src="//s2.51offer.com/51offer/2018-03-07/article-top.png" width="280">
          </a>
          <ul class="news-list">
            <li v-for="(item, index) in links">
              <a :href="item.link" target="_blank">{{item.title}}</a>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <MyToast :message="message" :toast="toast" :styles="styles"></MyToast>
  </div>
</template>

<script>
import { isNum } from '../libs/tools'
import { validate } from '../libs/validate'
import MyToast from './common/MyToast.vue'
import OneStep from './common/oneStep.vue'
import { getnotes, getbai, getwu, getlevel, getarticle } from '../libs/api'
export default {
  name: 'Gpa',
  data () {
    return {
      num: 4, // 课程数目默认为 4
      addNum: '', // 添加的课程数
      type: 1, // 1 百分制 2 五分制 3 等级制
      typeList: [
        {type: 1, context: '百分制'},
        {type: 2, context: '五分制'},
        {type: 3, context: '等级制'}
      ],
      showList: false,
      process: 1, // 1 计算 2 计算中 3 计算完成
      courses: [],
      item: {},
      message: '', // 弹窗提示信息
      toast: false, // 弹窗控制
      styles: { // 弹窗大小控制
        width: '70%'
      },
      notes: [],
      percent: '10%',
      newData: [],
      newData1: [],
      newData2: [],
      newData3: [],
      resultFirst: [],
      form: {}, // 验证错误信息
      validators: 'required,hundred,dotduble', // 验证规则,
      newsTop: 0,
      scrollTop: 0,
      links: [
        {
          title: '出国留学最详细的GPA换算方法',
          link: 'https://www.51offer.com/article/detail_67870.html'
        },
        {
          title: '经验分享 低GPA如何申请英国排名14的名校？',
          link: 'https://www.51offer.com/article/detail_58900.html'
        },
        {
          title: '英国硕士申请：学霸级别的好文书是怎样炼成的？',
          link: 'https://www.51offer.com/article/detail_71013.html'
        },
        {
          title: '申请美国大学研究生，你的GPA能申请到什么样的学校？',
          link: 'https://www.51offer.com/article/detail_89135.html'
        },
        {
          title: '出国留学GPA太低怎么办？四大挽救方案帮助你',
          link: 'https://www.51offer.com/article/detail_68004.html'
        },
        {
          title: '留学必看！澳大利亚最全GPA知识总结',
          link: 'https://www.51offer.com/article/detail_72107.html'
        }
      ],
      alloOffer: 0
    }
  },
  computed: {
    result () {
      switch (this.process) {
        case 2:
          return '正在计算...'
          break
        case 3:
          return '重新计算'
        default:
          return '开始计算'
      }
    },
    typeContext () {
      switch (this.type) {
        case 1:
          return '百分制'
          break
        case 2:
          return '五分制'
          break
        default:
          return '等级制'
      }
    },
    resultTips () {
      const per = this.percent.replace('%', '')
      if (per < 40.7) {
        return '不要灰心！还需要继续加油刷分，或者来51offer参加一些名校科研游学的背景提升项目，争取低分逆袭！'
      } else if (per > 79.50) {
        return '很棒！请注意：各国院校都会综合考察申请者的多维度能力，快免费咨询一下专业老师，查缺补漏自己的短板吧！'
      } else {
        return '还不错哦！要注意加强自己的文书及英语水平，51offer有专业的文书及语培服务，可以有效提高竞争力！'
      }
    },
    canSubmit () {
      const course = this.courses.some(item => Object.entries(item)[1][1] && Object.entries(item)[2][1])
      const validate = !Object.values(this.form).find((item) => item !== '')
      return course && validate && this.process !== 2
    },
    fixTop () {
      return this.scrollTop > this.newsTop
    }
  },
  created () {
    this.addItem(this.num)
    this.getNote()
  },
  mounted () {
    this.newsTop = this.$el.querySelector('#ad-news').offsetTop
    this.clientHeight = document.documentElement.clientHeight
    document.addEventListener('click', (e) => {
      setTimeout(() => {
        this.showList = false
        if (this.$el.querySelector('#ad-news').offsetTop >= this.newsTop) {
          this.newsTop = this.$el.querySelector('#ad-news').offsetTop
        }
      }, 100)
    })
    document.addEventListener('scroll', (e) => {
      setTimeout(() => {
        this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      }, 100)
    })
  },
  methods: {
    validateM (e) {
      validate(e, this)
    },
    bindV (t) {
      if (t === 1) {
        this.validators = 'required,hundred,dotduble'
      } else if (t === 2) {
        this.validators = 'required,five,dotsingle'
      } else {
        this.validators = 'required,rank'
      }
    },
    goAnchor(selector) {
      var anchor = this.$el.querySelector('#' + selector)
      document.body.scrollTop = anchor.offsetTop
      document.documentElement.scrollTop = anchor.offsetTop
    },
    chooseType (e) {
      this.showList = true
      e.stopPropagation();
    },
    bindType (item) {
      this.type = item.type
      this.showList = false
      this.courses = []
      this.addItem(this.num)
      this.addNum = ''
      this.bindV(item.type)
    },
    add () {
      if (isNum(this.addNum)) {
        this.addItem(this.addNum)
      } else {
        this.toast = true
        this.message = '请输入有效的数字'
        setTimeout(() => {
          this.toast = false
        }, 2000)
      }
    },
    clear () {
      this.courses = []
      this.addItem(this.num)
      this.addNum = ''
      this.type = 1
    },
    async submit () {
      if (!this.canSubmit) return
      this.process = 2
      if (this.type === 1) {
        await getbai(this.courses).then((res) => {
          this.formatData(res.data.data)
        }), (err) => {
          console.log(err)
        }
      } else if (this.type === 2) {
        await getwu(this.courses).then((res) => {
          this.formatData(res.data.data)
        }), (err) => {
          console.log(err)
        }
      } else {
        this.courses.forEach(item => {
          item['scoreStr'] = item['scoreStr'].toLocaleUpperCase()
        })
        await getlevel(this.courses).then((res) => {
          this.formatData(res.data.data)
        }), (err) => {
          console.log(err)
        }
      }
      this.process = 3
      this.newsTop = this.$el.querySelector('#ad-news').offsetTop
    },
    addItem (num) {
      if (this.type !== 3) {
        this.item = {course: '', score: '', level: ''}
        for (let i = 0; i < num; i++) {
          this.courses.push({...this.item, id: i + (new Date()).getTime()})
        }
      } else {
        this.item = {course: '', scoreStr: '', level: ''}
        for (let i = 0; i < num; i++) {
          this.courses.push({...this.item, id: i + (new Date()).getTime()})
        }
      }
    },
    getNote () {
      getnotes().then((res) => {
        this.notes = res.data.data.gpaCalc
      }), (err) => {
        console.log(err)
      }
    },
    formatData (result) {
      const _arr = []
      this.percent = result.percent || ''
      if (this.percent) delete result.percent
      Object.entries(result).forEach((item, index) => {
        this.notes.forEach((i) => {
          if (i.code === item[0]) {
            item[0] = i.value
            item[2] = item[1].split('/')[0]
            item[3] = item[1].split('/')[1]
          }
        })
        _arr.push(item)
      })
      this.newData = _arr
      if (this.type === 1) {
        this.newData1 = this.newData.slice(1, 3)
        this.newData2 = this.newData[3]
        this.newData3 = this.newData.splice(1, 3)
      }
      this.resultFirst = this.newData[0]
    },
    openTalk () {
      console.log(talk.open())
    }
  },
  components: {
    MyToast,
    OneStep
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .gap-container {
    background-color: #6290F8;
    padding-top: 30px;
    padding-bottom: 150px;
    min-width: 1200px;
  }

  .navbar {
    width: 1200px;
    margin: 0 auto;
    font-size: 14px;
    color: #FFFFFF;
    margin-bottom: 30px;
  }

  .form {
    width: 1200px;
    margin: 0 auto;
    background-color: #ffffff;
    padding-bottom: 80px;
  }

  .table {
    width: 900px;
    margin: 0 auto;
    &-banner {
      width: 100%;
      height: 120px;
      .banner {
        display: block;
        width: 100%;
        height: 100%;
        background: url("//s2.51offer.com/51offer/2018-03-07/gpa-banner.png") no-repeat center/cover;
      }
    }
    &-tool {
      font-size: 12px;
      color: #6290F8;
      padding: 30px 150px;
      &::before, &::after {
        content: '';
        clear: both;
      }
      .tips {
        float: left;
        cursor: pointer;
        &::before {
          display: inline-block;
          content: '';
          width: 16px;
          height: 16px;
          vertical-align: middle;
          margin-right: 4px;
          margin-bottom: 3px;
          background: url("//s2.51offer.com/51offer/2018-03-05/lights.png") no-repeat center/cover;
        }
      }
      .download, .upload {
        float: right;
        cursor: pointer;
        &::before {
          display: inline-block;
          content: '';
          width: 18px;
          height: 17px;
          vertical-align: middle;
          margin-right: 4px;
          margin-bottom: 3px;
          background: url("//s2.51offer.com/51offer/2018-03-05/down.png") no-repeat center/cover;
        }
      }
      .download {
        &::before {
          background: url("//s2.51offer.com/51offer/2018-03-05/down.png") no-repeat center/cover;
        }
      }
      .upload {
        margin-right: 20px;
        &::before {
          background: url("//s2.51offer.com/51offer/2018-03-05/upload.png") no-repeat center/cover;
        }
      }
    }
    &-title {
      text-align: center;
      font-size: 24px;
      font-weight: bold;
      color: #6290F8;
      padding: 10px;
      margin-top: 40px;
    }
    &-header {
      font-size: 18px;
      color: #4a4a4a;
      margin-top: 30px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      .label-name {
        width: 500px;
        float: left;
      }
      .score, .level {
        width: 200px;
        float: left;
        position: relative;
      }
      .typeContext {
        color: #6290F8;
        cursor: pointer;
        &::after {
          content: '';
          display: inline-block;
          margin-left: 5px;
          margin-bottom: 2px;
          width: 0;
          height: 0;
          border-left: 4px solid transparent;
          border-top: 6px solid #6290F8;
          border-right: 4px solid transparent;
        }
      }
      .type-list {
        position: absolute;
        top: 40px;
        right: 12px;
        width: 100px;
        background-color: #efefef;
        z-index: 99;
        & > li {
          cursor: pointer;
          background-color: #ffffff;
          &:nth-child(2n+1) {
            background-color: #f9f9f9;
          }
          &:hover {
            background-color: #cccccc;
          }
        }
      }
    }
    &-body {
      .item {
        width: 900px;
        height: 50px;
      }
    }
    .item {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      border: 1px solid #6290F8;
      box-shadow: inset 0 0 4px 0 rgba(98, 144, 248, 0.58);
      border-radius: 4px;
      font-size: 16px;
      margin-bottom: 30px;
      &:last-child {
        margin-bottom: 0;
      }
      span, input {
        height: 46px;
        font-size: 16px;
      }
      .index {
        width: 40px;
        color: #6290F8;
        text-align: center;
        line-height: 46px;
        border-right: 1px solid #6290F8;
      }
      input {
        text-align: center;
        border: none;
        outline: none;
        width: 200px;
        border-right: 1px solid #6290F8;
      }
      .input-course {
        width: 460px;
        padding-left: 18px;
        text-align: left;
      }
      .input-level {
        border-right: none;
      }
      .input-wrap {
        position: relative;
        .error {
          position: absolute;
          top: 50px;
          left: 10px;
          font-size: 12px;
          color: #F4548E;
        }
      }
    }
    .add {
      margin-top: 30px;
      display: flex;
      justify-content: flex-end;
      font-size: 14px;
      &-block {
        display: flex;
        flex: 1;
        justify-content: flex-end;
      }
      label {
        font-size: 14px;
        color: #333333;
      }
      .input-block {
        height: 24px;
        margin-left: 8px;
        border: 1px solid #6290F8;
        box-shadow: inset 0 0 3px 0 rgba(98, 144, 248, 0.60);
        border-radius: 4px;
        box-sizing: border-box;
        overflow: hidden;
        display: flex;
        input {
          width: 60px;
          border: none;
          outline: none;
          text-align: center;
        }
        div {
          background-color: #6290F8;
          color: #ffffff;
          border: none;
          outline: none;
          height: 22px;
          cursor: pointer;
          padding: 0 5px;
        }
      }
      &-tips {
        float: left;
        cursor: pointer;
        font-size: 12px;
        color: #6290F8;
        &::before {
          display: inline-block;
          content: '';
          width: 16px;
          height: 16px;
          vertical-align: middle;
          margin-right: 4px;
          margin-bottom: 3px;
          background: url("//s2.51offer.com/51offer/2018-03-05/lights.png") no-repeat center/cover;
        }
      }
    }

    .computed-wrap {
      margin-top: 26px;
      height: 50px;
      display: flex;
      justify-content: center;
      font-size: 18px;
      text-align: center;
      line-height: 50px;
      div {
        cursor: pointer;
      }
      .del-button {
        width: 80px;
        height: 50px;
        color: #CCCCCC;
        background: #FFFFFF;
        border: 1px solid #CCCCCC;
        border-radius: 4px;
        margin-right: 20px;
        &::before {
          content: '';
          display: inline-block;
          width: 18px;
          height: 18px;
          vertical-align: middle;
          margin-bottom: 3px;
          margin-right: 3px;
          background: url("//s2.51offer.com/51offer/2018-03-05/del-icon.png") no-repeat center/cover;
        }
      }
      .computed-button {
        width: 230px;
        height: 50px;
        color: #ffffff;
        background: #CCCCCC;
        border-radius: 4px;
        &-active {
          background: #6290F8;
        }
        &-computing {
          background-color: #F4548E;
        }
      }
    }
    .test {
      text-align: center;
      margin-top: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      a {
        font-size: 14px;
        color: #6290F8;
      }
      span {
        width: 12px;
        height: 12px;
        margin-left: 8px;
        background: url("//s2.51offer.com/51offer/2018-03-05/arrow-right.png") no-repeat center/cover;
      }
    }
  }

  .result {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #ffffff;
    padding: 80px 0;
    &-title {
      font-size: 24px;
      color: #333333;
      text-align: center;
    }
    &-form {
      width: 900px;
      margin-top: 40px;
      border: 1px solid #EEEEEE;
      border-top: none;
      .item-title1 {
        height: 40px;
        background: #FAFBFF;
        display: flex;
        border-top: 1px solid #EEEEEE;
        div {
          flex: 1;
          text-align: center;
          line-height: 40px;
          font-size: 14px;
          color: #999999;
          &:first-child {
            border-right: 1px solid #EEEEEE;
          }
        }
      }
      .item {
        height: 40px;
        display: flex;
        height: 60px;
        border-top: 1px solid #EEEEEE;
        div {
          flex: 1;
          text-align: center;
          line-height: 60px;
          font-size: 16px;
          color: #333333;
          &:first-child {
            border-right: 1px solid #EEEEEE;
          }
          &:last-child {
            color: #6290F8;
          }
        }
      }
    }
    &-suggest {
      margin-top: 50px;
      font-size: 20px;
    }
    &-tips {
      font-size: 14px;
      color: #999999;
      margin-top: 10px;
    }
    &-button {
      height: 50px;
      line-height: 50px;
      font-size: 18px;
      color: #ffffff;
      padding: 0 40px;
      margin-top: 40px;
      background-color: #6290F8;
      border-radius: 4px;
      cursor: pointer;
    }
  }

  .rule {
    width: 1200px;
    margin: 0 auto;
    display: flex;
  }

  .rule-detail {
    width: 750px;
    .title {
      font-size: 16px;
      color: #2B4395;
      margin-top: 40px;
      padding-left: 15px;
      position: relative;
      &::before {
        content: '';
        display: block;
        height: 18px;
        width: 8px;
        background-color: #2B4395;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .content {
      font-size: 14px;
      line-height: 24px;
      color: #FFFFFF;
      padding: 10px 10px 0 10px;
    }
    .connect {
      padding-left: 10px;
      display: flex;
      align-items: center;
      a {
        font-size: 14px;
        color: #8AEEFF;
      }
      span {
        width: 12px;
        height: 12px;
        margin-left: 6px;
        background: url("//s2.51offer.com/51offer/2018-03-05/arrow-right-a.png") no-repeat center/cover;
      }
    }
    .img-block {
      margin-top: 10px;
      padding-left: 10px;
    }
  }

  .ad {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .gap {
      width: 420px;
      height: 407px;
      background: url("https://s2.51offer.com/51offer/2018-02-05/PIC.png") no-repeat center/cover;
    }
    .news {
      margin-top: 120px;
      width: 300px;
      padding: 8px 0 80px 20px;
      border-left: 1px solid #83A1FF;
      &-title {
        font-size: 16px;
        color: #FFFFFF;
        font-weight: bold;
      }
      &-top {
        margin-top: 12px;
      }
      .banner {
        width: 280px;
        height: 180px;
        border-radius: 6px;
        overflow: hidden;
        background: #D8D8D8;
      }
      .info-section3 {
        margin: 30px 0;
        width: 280px;
        border-radius: 9px;
      }
      &-list {
        margin-top: 4px;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 28px;
        li {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          &::before {
            display: inline-block;
            vertical-align: middle;
            content: '';
            width: 6px;
            height: 6px;
            border-radius: 3px;
            margin-bottom: 3px;
            margin-right: 10px;
            background-color: #ffffff;
          }
          a {
            color: #ffffff;
          }
        }
      }
      &-fixed {
        position: fixed;
        top: -100px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Gpa.vue